export enum HighlightColors {
  RED = "red",
  YELLOW = "yellow",
  GREEN = "green",
  GRAY = "gray",
  LIGHT_BLUE = "light blue",
  DARK_BLUE = "dark blue",
  PURPLE = "purple",
  PINK = "pink",
}

export const enum NoteActions {
  DELETE = "delete",
  HIGHLIGHT = "highlight",
  CREATE_NOTE = "createNote",
  EXPLAIN = "explainMore",
  SIMPLIFY = "simplify",
  EXAMPLES = "examples",
  ASK = "ask",
}

export const ShortcutToNoteAction: Record<string, NoteActions> = {
  n: NoteActions.CREATE_NOTE,
  s: NoteActions.SIMPLIFY,
  m: NoteActions.EXPLAIN,
  e: NoteActions.EXAMPLES,
  h: NoteActions.HIGHLIGHT,
  a: NoteActions.ASK,
  backspace: NoteActions.DELETE,
};

export const NoteActionToShortcut: Record<NoteActions, string> = {
  [NoteActions.CREATE_NOTE]: "N",
  [NoteActions.SIMPLIFY]: "S",
  [NoteActions.EXPLAIN]: "M",
  [NoteActions.EXAMPLES]: "E",
  [NoteActions.HIGHLIGHT]: "H",
  [NoteActions.ASK]: "A",
  [NoteActions.DELETE]: `delete`,
};
